var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#FE2626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0312 20L24.9062 23.875C25 23.9688 25 24.125 24.9062 24.25L24.2188 24.9375C24.0938 25.0312 23.9375 25.0312 23.8438 24.9375L23.1875 24.2812L20 21.0625L16.125 24.9375C16.0312 25.0312 15.875 25.0312 15.75 24.9375L15.0625 24.25C14.9688 24.125 14.9688 23.9688 15.0625 23.875L18.9375 20L15.0625 16.1562C14.9688 16.0625 14.9688 15.9062 15.0625 15.7812L15.75 15.0938C15.875 15 16.0312 15 16.125 15.0938L20 18.9688L23.8438 15.0938C23.9375 15 24.0938 15 24.2188 15.0938L24.9062 15.7812C25 15.9062 25 16.0625 24.9062 16.1562L24.25 16.8125L21.0312 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedClose);
export default __webpack_public_path__ + "static/media/redClose.f37cfe9f07f65c3c1ef474e65f4dbb86.svg";
export { ForwardRef as ReactComponent };